import { Discord } from './discord';
import { Google } from './google';
import { Macroinsight } from './macroinsight';

export const Logos = {
  Macroinsight,
  Discord,
  Google
};
